import React from 'react'
import { inject, observer } from 'src/core/store'
import './index.less'
import { jumpToUser, jumpToRoom } from 'src/helper/webviewFun'
import score from 'src/helper/score'
import { setDocumentTitle, setUidToken } from 'src/helper/tool'
import ReactModal from 'react-modal'
import cdn from 'src/helper/avatar'
import DropScreen from '../../../component/DropScreen/index'
import http from 'src/helper/http'
import {
  apiGetCouplesList,
  apiGetLastWeekCouples,
  apiGetCouplesChampion,
  apiGetCouplesGiftList,
  apiGetMyCouplesList,
  apiCancelCP
} from 'src/helper/couples'
import VConsole from 'src/helper/vconsole'
import lang from './lang'
import { getlangV2, setlang } from 'src/helper/getlang'

@inject('store')
@observer

export default class Couples extends React.Component {
  constructor(props) {
    super(props)
  }
  state = {
    square: [],
    rank: [],
    champion: [],
    mycp: [],
    gift: [],
    current: 1,
    ts: 0,
    timers: 0,
    lang: lang.ar,
    visible: false,
    rrShow: false,
    language:'en',
    showModla:true,
  }

  async componentDidMount() {
    const uid = await setUidToken(this.props.location.query)
    this.setState({uid})
    // if (uid == 100619) {
    //    new VConsole()
    // }
    this.getUidInfosss(uid)
    // 埋点
    //this.$logEvent("cp_main_screen")
    setDocumentTitle('CP')

    let { language } = this.props.location.query
    let langM = lang
    
    language =await getlangV2(language, langM)
    this.pagesetIN(uid)
    this.setState({
      lang: setlang(language, lang),
      language: language,
      uid
    })
  }
  pagesetIN = async(uid)=>{
    this.handleGetCouplesList(uid)
    this.handleGetCouplesChampion()
    this.handleGetCouplesGiftList()
    this.handleGetLastWeekCouples()
    this.handleGetMyCPList()
  }

  async componentWillMount (){
    
  }

  getUidInfosss = async(uid)=>{
    let res =await http.post('/web/MyAccountInfo', {uid})
    if (res.code == 0) {
      if (res.res.region != 'tr') {
        this.setState({showModla:true})
      }else{
        this.setState({showModla:false})
      }
    }
  }
  async handleGetCouplesList(uid) {
    const { res } = await http.post('/web/cp/thisWeekRanking', {uid})
    this.setState({
      square: res && res.cpRanking || ""
    })
    this.setState(
      {
        ts: res && res.countDown
      },
      () => {
        // this.onCountdown()
      }
    )
    if (res && res.countDown > 0) {
      this.countDown(res && res.countDown)
    }
  }
  async handleGetCouplesChampion() {
    const { res } = await apiGetCouplesChampion()
    this.setState({
      champion: res && res.list || []
    })
  }
  async handleGetLastWeekCouples() {
    const { res } = await apiGetLastWeekCouples()
    console.log(res)
    this.setState({
      rank: res
    })
  }
  async handleGetCouplesGiftList() {
    const { res } = await apiGetCouplesGiftList()
    this.setState({
      gift: res
    })
  }

  async handleGetMyCPList() {
    const { res } = await apiGetMyCouplesList()
    this.setState({
      mycp: res && res.list || []
    })
  }

  componentWillUnmount() {
    clearInterval(this.state.timers)
  }

  handleSelected(index) {
    if (index == 1) {
      this.$logEvent("cp_thisweek_rank_show")
    }
    if (index == 2) {
      this.$logEvent("cp_lastweek_rank_show")
    }
    if (index == 3) {
      this.$logEvent("cp_reward")
    }
    this.setState({
      current: index
    })
  }

  onCountdown() {
    this.setState({
      timers: setInterval(() => {
        if (this.state.ts > 0) {
          this.setState({
            ts: this.state.ts - 1
          })
        } else {
          clearInterval(timers)
        }
      }, 1000)
    })
  }

  countDown = () => {
    let d  = Math.floor(new Date().getTime() /1000);
    let lostTime = 1722218400000 /1000
    if (d>= lostTime) {
       this.setState({ time: '00' + ':' + '00' + ':' + '00' })
       return
    }
    let times = lostTime-d
    var timer = null
    timer = setInterval(
      function () {
        var day = 0,
          hour = 0,
          minute = 0,
          second = 0
        if (times > 0) {
          day = Math.floor(times / (60 * 60 * 24))
          hour = Math.floor(times / (60 * 60)) - day * 24
          minute = Math.floor(times / 60) - day * 24 * 60 - hour * 60
          second = Math.floor(times) - day * 24 * 60 * 60 - hour * 60 * 60 - minute * 60
        }
        if (day <= 9) day = day
        if (hour <= 9) hour = '0' + hour
        if (minute <= 9) minute = '0' + minute
        if (second <= 9) second = '0' + second
        let daystr = ''
        if (day > 0) {
          // daystr = day
          daystr = ` ${day} ${this.state.lang.days} `
        }
        //
        this.setState({ time: daystr + hour + ':' + minute + ':' + second })
        times--
      }.bind(this),
      1000
    )
    if (times <= 0) {
      clearInterval(timer)
    }
  }

  onGetFormatTime(time) {
    const remainDay = Math.floor(time / (24 * 60 * 60))
      .toString()
      .padStart(2, '0')
    const remainTime = time % (24 * 60 * 60)
    const remainHour = Math.floor((remainTime / 3600) % 24)
      .toString()
      .padStart(2, '0')
    const remainMinutes = Math.floor((remainTime / 60) % 60)
      .toString()
      .padStart(2, '0')
    const remainSeconds = Math.floor(remainTime % 60)
      .toString()
      .padStart(2, '0')

    return `${remainDay}Day ${remainHour}h ${remainMinutes}m ${remainSeconds}s `
  }

  onDomain(url) {
    if (url.indexOf('aliyuncs.com') !== -1 || url.indexOf('thechatie.com') !== -1) {
      return cdn(url)
    }
    return url
  }

  renderCPSquare = () => {
    return (
      <div className="couples-square">
        <div className="couples-square--tips">
          {this.state.lang.title}
        </div>
        <div className="couples-square--rank">
          {this.state.gift && this.state.gift.map((item) => {
            return (
              <div key={item.ranking}>
                <div>
                  <div className="rank-avatar">
                    <img onClick={jumpToUser.bind(this, item.user1.uid)} src={this.onDomain(item.user1.avatarurl)} />
                  </div>
                  <p className="rank-name">{item.user1.nickname}</p>
                </div>
                <div className="rank-gift">
                  <img src={this.onDomain(item.gift.image)}></img>
                </div>
                <div>
                  <div className="rank-avatar">
                    <img onClick={jumpToUser.bind(this, item.user2.uid)} src={this.onDomain(item.user2.avatarurl)} />
                  </div>
                  <p className="rank-name">{item.user2.nickname}</p>
                </div>
              </div>
            )
          })}
        </div>
        <div className="couples-square--week">
          <div className="week-title">{this.state.lang.week}</div>
          <div className="week-time">
            <img src="/img/app/couples/love3.png" alt="" />
            {this.state.time}
            <img src="/img/app/couples/love3.png" alt="" />
          </div>

          <ul className="week-list">
            {this.state.square && this.state.square.map((item) => {
              return (
                <li key={item.ranking}>
                  {item.ranking === 1 ? (
                    <img src="/img/app/couples/rank_list1.png" />
                  ) : item.ranking === 2 ? (
                    <img src="/img/app/couples/rank_list2.png" />
                  ) : item.ranking === 3 ? (
                    <img src="/img/app/couples/rank_list3.png" />
                  ) : (
                    <span>{item.ranking}</span>
                  )}

                  <div className="week-list--avatar">
                    <img onClick={jumpToUser.bind(this, item.user1.uid)} src={this.onDomain(item.user1.avatarurl)} />
                    <img onClick={jumpToUser.bind(this, item.user2.uid)} src={this.onDomain(item.user2.avatarurl)} />
                  </div>
                  <div className="week-list--name">
                    <p>{item.user1.nickname}</p>
                    <p>{item.user2.nickname}</p>
                  </div>
                  <div className={`week-list--number ${this.state.language === 'ar' ? 'arlang' : ''}`}>
                    {score(item.intimacy)}
                    <img src="/img/app/couples/love.png" alt="" />
                  </div>
                </li>
              )
            })}
          </ul>
        </div>

        {this.renderMyCP()}
        <div className={`totalScore`}>{this.state.lang.totalScore}</div>
        {this.state.language !='tr' && <div className="service" onClick={jumpToUser.bind(this, 977239)}>
          {this.state.lang.service}
        </div>}
        {this.state.language =='tr' && <div className="service" onClick={jumpToUser.bind(this, 113742)}>
          {this.state.lang.service}
        </div>}
      </div>
    )
  }

  renderCPRank = () => {
    return (
      <div className="couples-rank">
        <div className="couples-rank--title">
          {this.state.lang.remark}
        </div>
        <div className="couples-rank--week">
          <div className="week-title">{this.state.lang.last}</div>
          <div className="week-content">
            <div className="week-content--container">
              {this.state.rank && this.state.rank.map((item) => {
                return (
                  <div key={item.ranking} className="container-content">
                    <div className="love"></div>
                    <div className="love-small1"></div>
                    <div className="container-avatar">
                      <img
                        onClick={jumpToUser.bind(this, item.user1.uid)}
                        src={this.onDomain(item.user1.avatarurl)}
                      ></img>
                      <img
                        onClick={jumpToUser.bind(this, item.user2.uid)}
                        src={this.onDomain(item.user2.avatarurl)}
                      ></img>
                    </div>
                    <p>
                      <span>{item.user1.nickname}</span>
                      <span style={{ padding: '0 0.1rem' }}>&</span>
                      <span>{item.user2.nickname}</span>
                    </p>
                    <p>{score(item.intimacy)}</p>
                  </div>
                )
              })}
            </div>
            <img src="/img/app/couples/rank_week1.png"></img>
          </div>
        </div>

        <div className="couples-rank--champion">
          <div className="champion-title">{this.state.lang.previous}</div>
          <div className="champion-wrapper">
            {this.state.champion.map((item) => {
              return (
                <div key={item.statdate} className="champion-wrapper--content">
                  <div className="love">
                    <div className="love-small"></div>
                  </div>
                  <div className="content-rangtime">{item.statdate}</div>
                  <div className="content-avatar--left">
                    <img onClick={jumpToUser.bind(this, item.user1.uid)} src={this.onDomain(item.user1.avatarurl)} />
                  </div>
                  <div className="content-avatar--right">
                    <img onClick={jumpToUser.bind(this, item.user2.uid)} src={this.onDomain(item.user2.avatarurl)} />
                  </div>
                  <div className="content-name--left">{item.user1.nickname} </div>
                  <div className="content-name--right">{item.user2.nickname} </div>
                  <div className="content-time">{this.state.lang.since} {item.statdate}</div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    )
  }

  renderMyCP = () => {
    return (
      <div style={{ margin: '1rem auto 0.5rem' }} className="couples-square--week">
        <div className="week-title">{this.state.lang.mycp}</div>
        <ul className="week-list">
          {this.state.mycp && this.state.mycp.map((item) => {
            return (
              <li key={item.ranking}>
                <div className='love-img'>
                  <img src="/img/app/couples/love2.png" alt="" />
                </div>
                {item.ranking === 1 ? (
                  <img src="/img/app/couples/rank_list1.png" />
                ) : item.ranking === 2 ? (
                  <img src="/img/app/couples/rank_list2.png" />
                ) : item.ranking === 3 ? (
                  <img src="/img/app/couples/rank_list3.png" />
                ) : (
                  <div></div>
                )}

                <div className="week-list--avatar week-list--avatar-flex">
                  <img onClick={jumpToUser.bind(this, item.user1.uid)} src={this.onDomain(item.user1.avatarurl)} />
                  <img onClick={jumpToUser.bind(this, item.user2.uid)} src={this.onDomain(item.user2.avatarurl)} />
                </div>
                <div className="week-list--name">
                  <p>{item.user1.nickname}</p>
                  <p>{item.user2.nickname}</p>
                </div>
                <div className="week-list--number">{score(item.intimacy)}</div>
                <div className='cancel' onClick={this.handleCancelCP.bind(this, item.cpid)}>
                  {' '}
                  {this.state.lang.clear}
                </div>
              </li>
            )
          })}
        </ul>
      </div>
    )
  }

  handleCancelCP(id) {
    this.setState({ visible: true })
    this.setState({ cpid: id })
  }
  handleCancel() {
    this.setState({ visible: false })
  }
  async handleConfirmCP() {
    await apiCancelCP(this.state.cpid)
    this.handleGetMyCPList()
    this.setState({ visible: false })
  }

  render() {
    let { showDay, mountDay, medalDay, vipDay, backgriundDay, headDay, headDays, goldScore, top2Gold, top3Gold, vip2Day, vip3Day }  = this.state.lang
    let { language, lang, showModla }  = this.state
    let rwList = [
      {
        title: language == 'tr'?'İlk 1':"TOP1",
        bigRw: {
          img: '/img/app/couples/rw/show.png',
          name: showDay
        },
        rwItem: [
          {
            img: '/img/app/couples/rw/mount.png',
            name: mountDay
          },
          {
            img: 'https://img.chatie.live/app/medal/images/cp1_l.png',
            name: medalDay
          },
          {
            img: '/img/app/couples/rw/duke.png',
            name: vipDay
          },
          {
            img: '/img/app/couples/rw/cp.jpg',
            name: backgriundDay
          },
          {
            img: '/img/app/couples/rw/m1.png',
            name: headDay
          },
          {
            img: '/img/app/couples/rw/w1.png',
            name: headDays
          },
          {
            img: '/img/gold.png',
            name: goldScore
          },
        ]
      },
      {
        title: language == 'tr'?'İlk 2':"TOP2",
        rwItem: [
          {
            img: 'https://img.chatie.live/app/medal/images/cp2_l.png',
            name: medalDay
          },
          {
            img: '/img/app/couples/rw/marquis.png',
            name: vip2Day
          },
          {
            img: '/img/app/couples/rw/cp.jpg',
            name: backgriundDay
          },
          {
            img: '/img/app/couples/rw/mount_Falcon.png',
            name: mountDay
          },
          {
            img: '/img/app/couples/rw/m2.png',
            name: headDays
          },
          {
            img: '/img/app/couples/rw/w2.png',
            name: headDays
          },
          {
            img: '/img/gold.png',
            name: top2Gold
          },
        ]
      },
      {
        title: language == 'tr'?'İlk 3':"TOP3",
        rwItem: [
          {
            img: 'https://img.chatie.live/app/medal/images/cp3_l.png',
            name:  medalDay
          },
          {
            img: '/img/app/couples/rw/count.png',
            name: vip3Day
          },
          {
            img: '/img/app/couples/rw/m3.png',
            name: headDays
          },
          {
            img: '/img/app/couples/rw/w3.png',
            name: headDays
          },
          {
            img: '/img/app/couples/rw/cp.jpg',
            name: backgriundDay
          },
          {
            img: '/img/gold.png',
            name: top3Gold
          },
        ]
      },
    ]
    return (
      <div className={`couples-wrapper ${this.state.language == 'ar' ? 'arlang' : ''}`}>
        {showModla && <div className='showmoldwe'>
          <div className='showmkookdoe'>{lang.showNewske}</div>
        </div>}
        {/* 屏幕爱心 */}
        <DropScreen></DropScreen>

        <div className="couples-wrapper--banner">
          {this.state.rank && this.state.rank.map((item) => {
            return (
              item.ranking === 1 && (
                <div key={item.ranking}>
                  <div className="banner-couples--avatar">
                    <div>
                      <img onClick={jumpToUser.bind(this, item.user1.uid)} src={this.onDomain(item.user1.avatarurl)} />
                    </div>
                    <div>
                      <img onClick={jumpToUser.bind(this, item.user2.uid)} src={this.onDomain(item.user2.avatarurl)} />
                    </div>
                  </div>
                  <div className="banner-couples--name">
                    <span>{item.user1.nickname}</span>
                    <span>{item.user2.nickname}</span>
                  </div>
                </div>
              )
            )
          })}
        </div>

        {/* 情人节限定 公告 */}
        {/* {
          this.state.time && (
            <div className="times">
              <img src="/img/app/couples/love3.png" alt="" />
              {this.state.time}
              <img src="/img/app/couples/love3.png" alt="" />
            </div>
          )
        } */}
        {/* <div className="yinyan">
        {this.state.lang.yy}
        <img src="/img/app/couples/love2.png" alt="" />
        </div> */}

        <div className="couples-wrapper--title">
          <div onClick={this.handleSelected.bind(this, 1)} className={this.state.current === 1 ? 'is-selected' : ''}>
            {this.state.lang.plaza}
          </div>
          <div onClick={this.handleSelected.bind(this, 2)} className={this.state.current === 2 ? 'is-selected' : ''}>
            {this.state.lang.rank}
          </div>
          <div onClick={this.handleSelected.bind(this, 3)} className={this.state.current === 3 ? 'is-selected' : ''}>
            {this.state.lang.reward}
          </div>
        </div>

        {this.state.current === 1 && this.renderCPSquare()}
        {this.state.current === 2 && this.renderCPRank()}
        {this.state.current === 3 &&
          (
            <div>
              <div className='cprw-rule'>
                <div className="reward-main">
                  {
                    rwList.map((item, index) => {
                      return (
                        <div className="reward-item" key={index}>
                          <div className="title">{item.title}</div>
                          {
                            item.bigRw && (
                              <div className="no1-bigRw">
                                <img src={item.bigRw.img} alt="" />
                                <div className="name">{item.bigRw.name}</div>
                              </div>
                            )
                          }
                          <div className="rw-main">
                            {
                              item.rwItem.map((item2, index2) => {
                                return (
                                  <div className="rw-item" key={index2}>
                                    <img src={item2.img} alt="" />
                                    <div className="name">{item2.name}</div>
                                  </div>
                                )
                              })
                            }
                          </div>
                        </div>
                      )
                    })
                  }
                </div>

                {/* 规则部分 */}
                <div className="cprw-rule__btn" onClick={() => {
                  this.$logEvent("cp_rule")
                  this.setState({
                    rrShow: true
                  })
                }}>
                  {this.state.lang.rewardtitle}
                </div>
                <div className="cprw-rule__content" style={{ display: this.state.rrShow ? "block" : "none" }}
                  onClick={() => {
                    this.setState({
                      rrShow: false
                    })
                  }}>
                  <div className="title">
                    {this.state.lang.rewardtitle}
                  </div>
                  <div
                    className={`cprw-rule__content__txt ${this.state.language == 'ar' && 'arfz'}`}
                    dangerouslySetInnerHTML={{ __html: this.state.lang.rewardRule }}
                  ></div>
                </div>

              </div>

              {/* 遮盖层 */}
              <div className="mhbg" style={{ display: this.state.rrShow ? "block" : "none" }}
                onClick={() => {
                  this.setState({
                    rrShow: false
                  })
                }}></div>

            </div>
          )

        }

        <ReactModal
          className={`couples-wrapper--modal ${this.state.language == 'ar' ? 'arlang' : ''}`}
          isOpen={this.state.visible}
          ariaHideApp={false}
        >
          <div>{this.state.lang.cp}</div>
          <div className="modal-button">
            <div className="button-cancel" onClick={this.handleCancel.bind(this)}>
              {this.state.lang.cancel}
            </div>
            <div onClick={this.handleConfirmCP.bind(this)} className="button-confirm">
              {this.state.lang.confirm}
            </div>
          </div>
        </ReactModal>

      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/couples/index.js